var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-0 px-md-3 px-0",attrs:{"fluid":"","fill-height":""}},[_vm._t("default",null,{"exposedData":_vm.exposedData})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }